import PropTypes from 'prop-types'
import defaults from '@config/defaults'
import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'
import EventCtaBox from '@components/event-cta-box/event-cta-box'
import Grid from '@material-ui/core/Grid'
import Container from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'
import LandingPageHeader from '@components/landing-page-header/index'
import ErrorBoundary from '@components/error/boundary'
import Hero from '@components/hero-events'
import ShowcaseEvent from '@components/showcase-event/index'
import MajorEventsCardContainer from '@components/major-events-card-container'
import StorySpotlightWithData from '@components/story-spotlight/story-spotlight.query'
import useStyles from './major-events-landing.styles'
import { FEATURED_STORIES_QUERY } from './major-events-landing.fragment'

const MajorEventsLanding = (props) => {
  const {
    query,
    headline,
    heroImage,
    featuredEvent,
    eventCategoriesCollection,
    showcaseEventHeadline,
    showcaseEvent,
    ctaBoxesCollection,
    metaTitle,
    metaDescription,
    metaImage,
  } = props

  const multiple = ctaBoxesCollection.items.length > 1
  const styles = useStyles({ multiple })
  const router = useRouter()

  return (
    <div className={styles.root}>
      <NextSeo
        noindex={defaults.noindexNofollow}
        nofollow={defaults.noindexNofollow}
        title={metaTitle}
        description={metaDescription}
        canonical={`${defaults.baseUrl}member-events`}
        openGraph={{
          title: metaTitle,
          type: 'website',
          url: `${defaults.baseUrl}${router.asPath.substring(1)}`, // trimming string because of /
          images: [{ url: (metaImage && metaImage.url) }],
        }}
      />
      <LandingPageHeader headline={headline} />
      <ErrorBoundary>
        <Hero
          headline={headline}
          heroImage={heroImage}
          featuredEvent={featuredEvent}
        />
      </ErrorBoundary>
      <ErrorBoundary>
        <MajorEventsCardContainer {...eventCategoriesCollection} />
      </ErrorBoundary>
      {showcaseEvent && (
        <ErrorBoundary>
          <ShowcaseEvent sectionHeadline={showcaseEventHeadline} {...showcaseEvent} />
        </ErrorBoundary>
      )}
      {ctaBoxesCollection?.items?.length && (
        <Container className={styles.ctaBoxWrapper}>
          <Grid container display="flex" className={styles.ctaBoxContainer}>
            {ctaBoxesCollection.items.map(item => (
              <EventCtaBox key={item.sys.id} {...item} className={styles.ctaBox} />
            ))}
          </Grid>
        </Container>
      )}
      <ErrorBoundary>
        <Box pt={0} className={styles.spotlightWrapper}>
          <StorySpotlightWithData
            graphqlQuery={FEATURED_STORIES_QUERY}
            parentCollection="majorEventsLandingCollection"
            query={query}
          />
        </Box>
      </ErrorBoundary>
    </div>
  )
}

MajorEventsLanding.propTypes = {
  query: PropTypes.object,
  headline: PropTypes.string,
  heroImage: PropTypes.shape({
    url: PropTypes.string,
  }),
  featuredEvent: PropTypes.shape({
    headline: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    slug: PropTypes.string,
    image: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  eventCategoriesCollection: PropTypes.shape({
    total: PropTypes.number,
    items: PropTypes.array,
  }),
  showcaseEventHeadline: PropTypes.string,
  showcaseEvent: PropTypes.shape({
    headline: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    slug: PropTypes.string,
    image: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  ctaBoxesCollection: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.object),
  }),
  metaTitle: PropTypes.string,
  metaDescription: PropTypes.string,
  metaImage: PropTypes.shape({
    url: PropTypes.string,
  }),
}

export default MajorEventsLanding
